import { PaginationInquiry } from "../../../../helper/pagination";
import { MOption } from "../../shared/shared.model";

export interface Customer {
  uuid: string;
  logo: string;
  what3words: string;
  commonName: string;
  name: string;
  registryNumber: string;
  promotionPoint: number;
  salesChannel: string;
  headCompanyRegister: string;
  headCompanyName: string;
  businessRegion: string;
  deliveryRegion: string;
  email: string;
  companyCode: string;
  address: string;
  phoneNumbers: string;
  companyType: string;
  taxPayerType: string;
  deactivated: boolean;
  contractId: number;
  priceTypeId: number;
  bankAccounts: BankAccount[];
  longitude: number;
  latitude: number;
  isSpecial: boolean;
}

export interface CustomerInquiry extends PaginationInquiry {
  name?: string;
  routeId?: string;
  companyCode?: string;
}

export enum ActionType {
  edit,
  delete,
}
export interface CustomerUI extends Customer, MOption {
  key?: number;
  index?: number;
  actions?: Action[];
  image?: any;
}

export interface Action {
  icon: string;
  text: string;
  type: ActionType;
}

export interface BankAccount {
  uuid: string;
  bankName: string;
  bankAccountNumber: string;
  customer?: any;
}

export interface FileResponse {
  fileName: string;
  fileDownloadUri: string;
  fileType: string;
  size: number;
}
